import $ from "jquery"
import loadjs from "loadjs"
$(document).ready(function () {
  loadjs("vendor/bootstrap/js/bootstrap.js")
  $('.navbar2').width($(window).width() - $('#accordionSidebar').width() - 30)

  //   $('.requests2').on('click' , function () {
  //     $('#dataTable').dataTable();
  //     $(this).css("display" , "none");
  // })

  window.onresize = function () {
    $('.navbar2').width($(window).width() - $('#accordionSidebar').width() - 30)
    $('.notificationsList').height($(window).height() * (6 / 10))
  }

  $("#sidebarToggle, #sidebarToggleTop").on('click', function (e) {

    $("body").toggleClass("sidebar-toggled");
    $(".sidebar").toggleClass("toggled");
    // if ($(".sidebar").hasClass("toggled")) {
    //   $('.sidebar .collapse').collapse('hide');
    // };
    $('.navbar2').width($(window).width() - $('#accordionSidebar').width() - 30)
  });


  $(".nav-item").on('click', function (e) {
    if ($(window).width() < 768) {
      $("body").removeClass("sidebar-toggled");
      $(".sidebar").addClass("toggled");
      $('.navbar2').width($(window).width() - $('#accordionSidebar').width() - 30)
    }
  });
  // Close any open menu accordions when window is resized below 768px
  $(window).resize(function () {
    if ($(window).width() < 768) {
      // $('.sidebar .collapse').collapse('hide');
      $("body").removeClass("sidebar-toggled");
      $(".sidebar").addClass("toggled");
      $('.navbar2').width($(window).width() - $('#accordionSidebar').width() - 30)
    };
  });

  // Prevent the content wrapper from scrolling when the fixed side navigation hovered over
  $('body.fixed-nav .sidebar').on('mousewheel DOMMouseScroll wheel', function (e) {
    if ($(window).width() > 768) {
      var e0 = e.originalEvent,
        delta = e0.wheelDelta || -e0.detail;
      this.scrollTop += (delta < 0 ? 1 : -1) * 30;
      e.preventDefault();
    }
  });

  // Scroll to top button appear
  $(document).on('scroll', function () {
    var scrollDistance = $(this).scrollTop();
    if (scrollDistance > 100) {
      $('.scroll-to-top').fadeIn();
    } else {
      $('.scroll-to-top').fadeOut();
    }
  });

  // Smooth scrolling using jQuery easing
  $(document).on('click', 'a.scroll-to-top', function (e) {
    var $anchor = $(this);
    $('html, body').stop().animate({
      scrollTop: ($($anchor.attr('href')).offset().top)
    }, 1000, 'easeInOutExpo');
    e.preventDefault();
  });

});